module.exports = __webpack_public_path__ + "img/eq-lazarusspire.10adcb94.png";